// extracted by mini-css-extract-plugin
module.exports = {"emergencySwitcher":"styles_emergencySwitcher__395S_"};